var $ = require('jquery');
var auth = require('../auth');
require('./tmpl-renderer');

var VALID_SUCCESS = 'success.valid', VALID_ERROR = 'error.valid';

$.fn.ycgameLoginForm = function (globalOptions) {
    return this.each(function () {
        var $self = $(this);

        var options = $.extend({
            successTmpl: $self.next('script[type="text/x-template"]').size() ? $self.next('script[type="text/x-template"]') : null
        }, globalOptions);

        if (options.successTmpl) {
            $self.on('success.submit', function () {
                $self.ycgameTmplRender({template: options.successTmpl});
            });
        }

        var $captchaRow = $self.find('[role=ycgame-login-captcha]');
        var $captchaImg = $self.find('img[role=ycgame-login-img-captcha]');
        $self.on('click', 'img[role=ycgame-login-img-captcha]', function (e) {
            e.preventDefault();
            this.src = "http://i.ycgame.com/CheckCode.aspx?datetime=" + new Date;

            return false;
        }).one('change blur keyup', 'input', function () {
            if (this.value && $captchaRow.is(':hidden')) {
                $captchaRow.show().find('img').click();
            }
        }).on('blur', '[name=username]', function (e) {
            var self = $(this);
            var val = self.val();
            if (!val) {
                self.trigger(VALID_ERROR, ['请输入用户名']);
            } else {
                self.trigger(VALID_SUCCESS);
            }
        }).on(VALID_ERROR + ' ' + VALID_SUCCESS, 'input', function (e) {
            $(this).data('valid', e.type === 'success');
        }).on('blur', '[name=password]', function () {
            var self = $(this);
            if (!this.value) {
                self.trigger(VALID_ERROR, ['请输入密码']);
            } else {
                self.trigger(VALID_SUCCESS);
            }
        }).on('blur', '[name=captcha]', function () {
            var self = $(this);
            if (!this.value) {
                self.trigger(VALID_ERROR, ['请输入图形验证码']);
            } else {
                self.trigger(VALID_SUCCESS);
            }
        }).on('submit', function (e) {
            e.preventDefault();
            var username = this.username;
            var password = this.password;
            var captcha = this.captcha;
            var $self = $(this);

            var canSubmit = true;
            $self.find('input:enabled').each(function () {
                var $input = $(this);
                if ($input.data('valid') === false) {
                    this.focus();
                    canSubmit = false;
                    return false;
                } else if (!$input.data('valid')) {
                    $input.trigger('blur');
                    canSubmit = $input.data('valid');
                    if (!canSubmit) {
                        this.focus();
                        return false;
                    }
                }
            });

            if (canSubmit) {
                auth.login(username.value, password.value, captcha.value).done(function (result) {
                    $self.trigger('success.submit', [result]);
                }).fail(function (result) {
                    if (result) {
                        $captchaImg.click();
                        captcha.value = '';
                        $self.trigger('error.submit', [result.msg]);
                    } else {
                        $self.trigger('error.submit', ['服务异常']);
                    }
                });
            }
        });

        $self.find('input').each(function () {
            if (this.value && $captchaRow.is(':hidden')) {
                $captchaRow.show().find('img').click();
            }
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./components/login-form.js
// module id = 10
// module chunks = 0